﻿import { useSlideout } from '@iress-oss/ids-components';
import { Nullable, Scenario } from '@xplan-pension-switching/common';
import { useState } from 'react';

export const useScenarioSlideout = () => {
    const { showSlideout } = useSlideout();
    const [scenario, setScenario] = useState<Nullable<Scenario>>(null);

    const showScenarioSlideout = (scenario: Scenario) => {
        setScenario(scenario);
        showSlideout('view-report-slideout', true);
    };

    return {
        showScenarioSlideout,
        scenario,
    };
};
